(function () {
  function getSelectedColor(section) {
    const variantSelects = document.querySelector(`variant-selects[data-section="${section}"]`);
    if (!variantSelects) return null;

    let colorValue = null;

    variantSelects.querySelectorAll('fieldset').forEach((fs) => {
      const legend = fs.querySelector('legend');
      const label = legend ? legend.textContent.trim().toLowerCase() : '';
      if (label.startsWith('color') || label.startsWith('colour')) {
        const checked =
          fs.querySelector('input[type="radio"].cvo-input:checked') ||
          fs.querySelector('input[type="radio"]:checked');
        if (checked) colorValue = checked.value.trim().toLowerCase();
      }
    });

    return colorValue;
  }

  function shouldShow(mediaColor, color) {
    if (!color) return true;
    if (!mediaColor) return false;
    return mediaColor === color;
  }

  function runFilter(section) {
    const color = getSelectedColor(section);
    if (!color) return;

    const gallery = document.getElementById(`MediaGallery-${section}`);
    if (!gallery) return;

    if (typeof gallery.setActiveMedia !== 'function') {
      return;
    }

    const viewerItems = gallery.querySelectorAll('[id^="GalleryViewer"] li[data-media-id]');
    const thumbItems = gallery.querySelectorAll('[id^="GalleryThumbnails"] li[data-target]');

    let firstVisibleMediaId = null;

    viewerItems.forEach((li) => {
      const mediaColor = (li.dataset.mediaColor || '').toLowerCase();
      const visible = shouldShow(mediaColor, color);
      li.classList.toggle('gallery-item--hidden', !visible);
      if (visible && !firstVisibleMediaId) {
        firstVisibleMediaId = li.dataset.mediaId;
      }
    });

    thumbItems.forEach((li) => {
      const mediaColor = (li.dataset.mediaColor || '').toLowerCase();
      const visible = shouldShow(mediaColor, color);
      li.classList.toggle('gallery-item--hidden', !visible);
    });

    window.dispatchEvent(new Event('resize'));

    if (firstVisibleMediaId) {
      const activeItem = gallery.querySelector('[id^="GalleryViewer"] li.is-active');
      if (activeItem && activeItem.classList.contains('gallery-item--hidden')) {
        gallery.setActiveMedia(firstVisibleMediaId, true);
      } else {
        gallery.setActiveMedia(firstVisibleMediaId, false);
      }
    }
  }

  function runModalFilter(section) {
    const color = getSelectedColor(section);
    if (!color) return;

    const modal = document.getElementById(`ProductModal-${section}`);
    if (!modal) return;

    const modalItems = modal.querySelectorAll('.product-media-modal__media-wrapper[data-media-id]');

    modalItems.forEach((wrapper) => {
      const mediaColor = (wrapper.dataset.mediaColor || '').toLowerCase();
      const visible = shouldShow(mediaColor, color);
      wrapper.classList.toggle('gallery-item--hidden', !visible);
    });
  }

  function filterGallery(section) {
    if (customElements.get('media-gallery')) {
      customElements.whenDefined('media-gallery').then(() => runFilter(section));
    } else {
      runFilter(section);
    }
    runModalFilter(section);
  }

  // ✅ 1. Instant click filter — AJAX se pehle hi turant switch (feels fast, no lag)
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== 'radio' || !input.classList.contains('cvo-input')) return;

    const fieldset = input.closest('fieldset');
    const legend = fieldset ? fieldset.querySelector('legend') : null;
    const label = legend ? legend.textContent.trim().toLowerCase() : '';
    if (!label.startsWith('color') && !label.startsWith('colour')) return;

    const section = input.closest('variant-selects')?.dataset.section;
    if (section) filterGallery(section);
  });

  // ✅ 2. AJAX-swap detect: jab Shopify ka fetch() gallery/product-info ka HTML replace kare,
  // childList mutation catch karo (attribute changes ignore — hamari hi filter loop na bane)
  const debounceMap = new Map();
  function debouncedFilter(section) {
    if (debounceMap.has(section)) clearTimeout(debounceMap.get(section));
    debounceMap.set(
      section,
      setTimeout(() => {
        filterGallery(section);
        debounceMap.delete(section);
      }, 50)
    );
  }

  function attachAjaxObserver(section) {
    const targets = [
      document.getElementById(`MediaGallery-${section}`),
      document.querySelector(`variant-selects[data-section="${section}"]`),
      document.getElementById(`product-info-${section}`),
      document.querySelector(`product-info[data-section="${section}"]`)
    ].filter(Boolean);

    targets.forEach((target) => {
      if (target.dataset.ajaxObserverAttached) return;
      target.dataset.ajaxObserverAttached = 'true';

      const observer = new MutationObserver(() => {
        debouncedFilter(section);
      });

      // ✅ Sirf structural changes (naye/purane nodes add-remove) sunte hain —
      // attribute changes (jaise humari khud ki class toggle) ignore ho jaati hain,
      // isliye infinite loop nahi banega
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  function initAll() {
    document.querySelectorAll('variant-selects').forEach((vs) => {
      const section = vs.dataset.section;
      filterGallery(section);
      attachAjaxObserver(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('product-info:loaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState !== 'loading') initAll();
})();